/* BSFN homepage — shared behaviour: scroll reveals + product gallery arrows.
   Idempotent: safe even if loaded by several sections. */
(function(){
  if(window.__bsfnReady){return;}
  window.__bsfnReady=true;

  function init(){
    try{
      var els=document.querySelectorAll('.bsfn-home .reveal');
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(en){
          en.forEach(function(e){
            if(e.isIntersecting){
              var sib=Array.prototype.indexOf.call(e.target.parentNode.children,e.target);
              e.target.style.transitionDelay=(Math.min(sib,5)*0.07)+'s';
              e.target.classList.add('in');
              io.unobserve(e.target);
            }
          });
        },{threshold:0.12,rootMargin:'0px 0px -6% 0px'});
        els.forEach(function(el){io.observe(el);});
      }else{
        els.forEach(function(el){el.classList.add('in');});
      }
      /* safety net: reveal everything after a few seconds no matter what */
      setTimeout(function(){
        document.querySelectorAll('.bsfn-home .reveal').forEach(function(el){el.classList.add('in');});
      },3500);

      /* product gallery arrows (present only when the platform section is) */
      var g=document.getElementById('bsfn-gallery');
      if(g){
        var stepBy=function(){var c=g.querySelector('.gcard');return c?c.getBoundingClientRect().width+22:340;};
        var pv=document.getElementById('bsfn-gprev'),nx=document.getElementById('bsfn-gnext');
        if(pv){pv.addEventListener('click',function(){g.scrollBy({left:-stepBy(),behavior:'smooth'});});}
        if(nx){nx.addEventListener('click',function(){g.scrollBy({left:stepBy(),behavior:'smooth'});});}
      }
    }catch(err){
      try{document.querySelectorAll('.bsfn-home .reveal').forEach(function(el){el.classList.add('in');});}catch(e){}
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{
    init();
  }
})();
